export enum ReleaseSortField {
  TRANSACTION_NUMBER,
  RELEASE_OFFICE,
  RELEASE_DATE,
  ACCOUNTING,
  CUSTOMS_BROKER,
  RELEASE_VALUE
}

export enum CalculatedViews {
  DECLARATION_TOTALS = 'DECLARATION_TOTALS',
  VENDOR_TOTALS = 'VENDOR_TOTALS',
  GOOD_TOTALS = 'GOOD_TOTALS',
}

export enum CADType {
  DECLARATION = 'DECLARATION',
  ROI = 'ROI',
  TEMPORARY_IMPORTATION = 'TEMPORARY_IMPORT',
  DUTY_DRAWBACK = 'DUTY_DRAWBACK',
  MASS_ADJUSTMENT = 'MASS_ADJUSTMENT',
  ADJUSTMENT = 'ADJUSTMENT',
  CONVERT_B3 = 'CONVERT_B3',
  SDA = 'SDA',
  MPRCC = 'MPRCC',
  RDDB  = 'RDDB',
}
export enum DDBType {
  PRE_CARM = 'PRE_CARM',
  POST_CARM = 'POST_CARM',
}

export enum CADCashType {
  AWAITING_RESPONSE_TYPE = 'AR',
  ROF = 'ROF'
}

export enum DraftStatus {
  Draft = 'DRAFT',
  Complete = 'Complete',
}

export enum CadStatus {
  Complete = 'E0006',
  Created = 'E0003',
  Processed = 'E0002',
  InProcess = 'E0001',
  ToBeApproved = 'E0013',
  ApprovedE0011 = 'E0011',
  ApprovedE0002A = 'E0002A',
  RejectedE0012 = 'E0012',
  RejectedE0002R = 'E0002R',
  CancelledE0007 = 'E0007',
  CancelledE0014 = 'E0014',
  AwaitingCadE0004 = 'E0004',
  AwaitingCadE0005 = 'E0005',
}

export enum TempImportStatus {
  Created = 'E0001',
	Admitted = "E0002",
	Acquitted = "E0003",
	Cancelled = "E0004",
}

export enum RoiStatus {
  AwaitingCad = 'E0001',
  Completed = 'E0002',
	Cancelled = 'E0003'
}

export enum DDBStatus {
  Created = 'E0001',
  InProgress = 'E0002',
  ToBeApproved = 'E0003',
  Approved = 'E0004',
  Rejected = 'E0005',
  Processed = 'E0006',
  Cancelled = 'E0007',
}

export enum CadStep {
  Overview = 'OVERVIEW',
  GeneralDetails = 'GENERAL_DETAILS',
  Warehouse = 'WAREHOUSE',
  Invoices = 'INVOICES',
  Review = 'REVIEW',
  Attachments = 'ATTACHMENTS'
}

export enum AdjustStep {
  Review = 'ADJUSTREVIEW',
  Submit = 'SUBMIT',
  Justification = 'JUSTIFICATION',
  Edit = 'EDIT',
  Delete = 'DELETE',
  Changes = 'CHANGES',
  Save = 'SAVE',
}

export enum TempImpStep {
  Overview = 'OVERVIEW_TEMP',
  GeneralDetails = 'GENERAL_DETAILS_TEMP',
  Destination = 'DESTINATION_TEMP',
  Dates = 'DATES_TEMP',
  VendorsGoods = 'VENDORS-GOODS_TEMP',
  Review = 'REVIEW_TEMP'
}

export enum DutyDrawbackStep {
  GeneralDetails = 'GENERAL_DETAILS',
  SelectLines = 'SELECT_LINES',
  Claims = 'CLAIMS',
  Review = 'REVIEW'
}

export enum PreCarmDutyDrawbackStep {
  SelectTransactions = 'SELECT_TRANSACTIONS',
  GeneralDetails = 'GENERAL_DETAILS',
  SelectLines = 'SELECT_LINES',
  Claims = 'CLAIMS',
  Review = 'REVIEW',
  AddAttachments = 'ADD_ATTACHMENTS'
}

export enum MassAdjustmentStep {
  Reason = 'REASON',
  AdjustmentLevel = 'ADJUSTMENT_LEVEL',
  AdjustFields = 'ADJUST_FIELDS',
  Review = 'Mass_REVIEW'
}

export enum SDAStep {
  CreateCase = 'CREATE_CASE',
  UploadFile = 'UPLOAD_FILE',
}

export enum RDDBStep {
  ClaimantDetails = 'CLAIMANT_DETAILS',
  UploadFile = 'UPLOAD_FILE',
}

export enum ModeOfTransport {
  Air = '01',
  Highway = '02',
  Postal = '05',
  Rail = '06',
  Pipeline = '07',
  CommercialHandCarriedGoods = '08',
  Marine = '09',
  ElectricalGrid = '10'
}

export enum DeclarationType {
  WarehouseIn_10 = '10',
  ReWarehouse_13 = '13',
  ExWarehouseForConsumption_20 = '20',
  ExWarehouseForExport_21 = '21',
  TransferOfGoods_30 = '30',
  WithRelease_AB = 'AB',
  ToObtainReleaseOfGoods_C = 'C',
  CourierLowValueShipment_F = 'F',
  CustomsSelfAssessment_TT = 'TT',
  Voluntary_V = 'V'
}

export enum PreCarmType {
  IsDeclared = '1',
  IsAdjusted = '2'
}

export enum MPRCCStep {
  CreateCase = 'CREATE_CASE',
  UploadFile = 'UPLOAD_FILE',
  UploadFileFinal = 'UPLOAD_FILE_FINAL',
}

export enum LevelOfAdjustment {
  DETAILS_WAREHOUSE = 'H',
  INVOICE = 'S',
  GOODS = 'C',
}

export enum DDBErrorType {
  HEADER = 'Header',
  SUBHEADER = 'Subheader',
  COMMODITY = 'Commodity',
  EXPORT = 'Export',
}

export enum MpReqStatus {
  Cancelled = 'Cancelled',
  Closed = 'Closed',
  InProgress = 'In_Progress',
  DecisionRendered = 'Decision_Rendered'
}

